<div class="row">
  <div class="col-md-9">
    <h1 mat-dialog-title>Validation Error</h1>
  </div>
  <div class="col-md-3">
    <button class="btn btn-danger pull-right" (click)="closeDialog()">X</button>
  </div>
</div>
<div mat-dialog-content>
  <p>Please click search befor Export</p>
</div>
<div class="pull-right mt-2">
  <button class="btn btn-danger" (click)="closeDialog()">OK</button>
</div>
